import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-help-center', en)

export * from './src/pages/default'
export * from './src/constants'
